/**
 * Ob der „Plan: …"-Hinweis neben einem Ziel erscheint — eigene, reine
 * Funktion statt Vergleich im JSX, weil der reine Wertevergleich (`plan !==
 * aktuell`) den Zustand der Zielrunde ignoriert und dadurch zwei fachlich
 * verschiedene Fälle verwechselt, in denen `plan` `NULL` ist:
 *
 *  (a) Die Zielrunde wurde NIE eingefroren. Das ist der Normalzustand nach
 *      jedem Deploy, bis jemand zum ersten Mal einfriert — es gibt schlicht
 *      noch keinen Plan.
 *  (b) Die Runde WURDE eingefroren, und damals war für diese Zeile nichts
 *      geplant. Dann gibt es sehr wohl einen Plan, er lautet „nichts" — und
 *      steht heute ein Ist/Ziel daneben, ist das eine echte Abweichung.
 *
 * Der Unterschied steckt nicht im Wert (`null`), sondern im Zustand der
 * Runde: Nur `"eingefroren"` bedeutet „ein Plan existiert überhaupt". Ohne
 * diese Unterscheidung zeigte die Oberfläche an allen sechs Stellen
 * „Plan: –", solange nie eingefroren wurde — genau das verbietet die Regel
 * (Zielrunde-Spec, Abschnitt Oberfläche).
 */
export function zeigePlan(
  zielrundeStatus: "offen" | "eingefroren" | undefined,
  plan: number | null | undefined,
  aktuell: number | null | undefined,
): boolean {
  if (zielrundeStatus !== "eingefroren") return false;
  return plan !== undefined && (plan ?? null) !== (aktuell ?? null);
}
